import * as React from 'react';
import {
  useState,
  useMemo,
  useCallback,
  useRef,
} from 'react';

import MapGL, { NavigationControl, Source, Layer, Popup } from 'react-map-gl';

import zones from '../mapdata/combined-unique.json'
import ccr_zones from '../mapdata/ccr.json'
import zonesLabels from '../mapdata/combined-unique-labels.json'
import MapStyles from '../lib/MapStyles'

const MAPBOX_TOKEN = 'pk.eyJ1IjoiZW50c29lIiwiYSI6ImNraWhkMnE4NzFyazEyc3JzN3ZtbTJpNmIifQ.onUVeIRBeWYowlTBGTpAVg'; // Set your mapbox token here


const mapStyle = { version: 8, sources: {}, layers: [], "glyphs": "mapbox://fonts/entsoe/{fontstack}/{range}.pbf" };

const styles = MapStyles;

const all_zones = {
    type: 'FeatureCollection',
    features: [...zones.features, ...ccr_zones.features]
};

function Root(props) {

  const {
    // selectedZone,
    zoneIds,
    // onMouseMove,
    onZoneClick
  } = props
  
  const ref = useRef(null);
  const [hoveredZoneId, setHoveredZoneId] = useState(null);
  // const [zonesGeo, setZonesGeo] = useState(zones);

  const [tooltipPosition, setTooltipPosition] = useState(null);
  // const [tooltipZoneData, setTooltipZoneData] = useState(null);

  const [viewport, setViewport] = useState({
    latitude: 50.82,
    longitude: 10.054,
    zoom: 2,
    minZoom: 1.5,
    maxZoom: 6,
    bearing: 0,
    pitch: 0
  });
  

  // Generate two sources (clickable and non-clickable zones), based on the zones data.
  const sources = useMemo(() => {
    return {
      zonesClickable: {
        type: 'FeatureCollection',
        features: all_zones.features.filter(f => {
          // strings.some(v => a.EicTypeFunctionList.includes(v))
          // zoneIds.some(v => a.EicTypeFunctionList.includes(v))
          return zoneIds.some(v => f.properties.id === v)
        }),
      },
      zonesNonClickable: all_zones,
      zonesLabels: {
        type: 'FeatureCollection',
        features: zonesLabels.features.filter(f => {
          // strings.some(v => a.EicTypeFunctionList.includes(v))
          // zoneIds.some(v => a.EicTypeFunctionList.includes(v))
          return zoneIds.some(v => f.properties.id === v)
        }),
      }
    };
  }, [zoneIds]);

  // Every time the hovered zone changes, update the hover map layer accordingly.
  const hoverFilter = useMemo(() => (['==', 'id', hoveredZoneId || '']), [hoveredZoneId]);
  // filter to use to hightlight multiple areas
  // const hoverFilter = useMemo(() => (["in",['get', 'id'],['literal', ["10Y1001A1001A44P", "10YFR-RTE------C"]] || '']), [hoveredZoneId]);

  const handleMouseMove = useCallback((e) => {
    // if (hoveringEnabled) {
      // onMouseMove({
      //   x: e.point[0],
      //   y: e.point[1],
      //   longitude: e.lngLat[0],
      //   latitude: e.lngLat[1],
      // });
    setTooltipPosition({
      x: e.point[0],
      y: e.point[1],
      longitude: e.lngLat[0],
      latitude: e.lngLat[1],
    });
    // }
    // Ignore zone hovering when dragging (performance optimization).
    // if (!isDragging) {
    const features = ref.current.queryRenderedFeatures(e.point, {layers: ['active-zone']});
    // Trigger onZoneMouseEnter if mouse enters a different
    // zone and onZoneMouseLeave when it leaves all zones.
    
    if (features.length) {
      const { id } = features[0].properties;
      if (hoveredZoneId !== id) {
        // onZoneMouseEnter(zones[zoneId], zoneId);
        setHoveredZoneId(id);
      }
    } else if (hoveredZoneId !== null) {
      // onZoneMouseLeave();
      setHoveredZoneId(null);
    }
    // }
    
  }, [hoveredZoneId]);




  const handleMouseOut = useCallback(() => {
    if (hoveredZoneId !== null) {
      setHoveredZoneId(null);
    }
  }, [hoveredZoneId]);
  
  
  const handleClick = useCallback((e) => {
    if (ref.current) {
      const features = ref.current.queryRenderedFeatures(e.point, {layers: ['active-zone']});
      if (!features.length) {
        console.log('No click on zone')
      } else {
        onZoneClick(features[0].properties.id);
      }
    }
  }, [onZoneClick]);


  const RenderPopup = () => {
   return <Popup
      tipSize={5}
      anchor="top"
      longitude={tooltipPosition.longitude}
      latitude={tooltipPosition.latitude}
      closeButton={false}
      /*closeOnClick={true}*/
      /*onClose={() => console.log('Popup closed')}*/
    >
      {hoveredZoneId}
    </Popup>;
  }

  return (
    <div>
    <div style={{
      padding: '1rem',
      marginLeft: '210px',
      background: '#eee'
    }}>
      {sources.zonesClickable.features.length === 0 ? 'There is currently no matching geo for this area' : `Found ${sources.zonesClickable.features.length} matching geographic feature`}
    </div>
    {sources.zonesClickable.features.length !== 0 && <MapGL
      {...viewport}
      ref={ref}
      width="100%"
      height="90vh"
      mapStyle={mapStyle}
      onMouseMove={handleMouseMove}
      onMouseOut={handleMouseOut}
      onViewportChange={nextViewport => setViewport(nextViewport)}
      mapboxApiAccessToken={MAPBOX_TOKEN}
      onClick={handleClick}
      // mapOptions={{hash: true}}
    >
      <div
          className="mapboxgl-zoom-controls"
          style={{
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.15)',
            position: 'absolute',
            right: '24px',
            top: '24px',
          }}
        >
          <NavigationControl
            showCompass={false}
            zoomInLabel=""
            zoomOutLabel=""
          />
        </div>
        
        {tooltipPosition && hoveredZoneId && (
          <RenderPopup />
        )}
        <Layer id="ocean" type="background" paint={styles.ocean} />
        <Source type="geojson" data={sources.zonesNonClickable}>
          <Layer id="zones-static" type="fill" paint={styles.zonesNonClickable} />
          <Layer id="zones-static-line" type="line" paint={styles.zonesNonClickableLine} />
        </Source>
        <Source type="geojson" data={sources.zonesClickable}>
          <Layer id="active-zone" type="fill" paint={styles.zonesClickable} />
          <Layer id="active-zone-line" type="line" paint={styles.zonesClickableLine} />
        </Source>
        <Source type="geojson" data={sources.zonesLabels}>
          <Layer id="active-zone-label" type="symbol" paint={styles.zonesClickableLabel.paint} layout={styles.zonesClickableLabel.layout} />
        </Source>
        <Source type="geojson" data={sources.zonesClickable}>
          <Layer id="hover" type="fill" paint={styles.hover} filter={hoverFilter} />
        </Source>
        {props.children}
    </MapGL>}
    </div>
  );
}

export default Root;

// document.body.style.margin = 0;
// render(<Root />, document.body.appendChild(document.createElement('div')));